G.BOT = function(board) {
  Phaser.Group.call(this, game);
  this.board = board;

  this.active = false;
  this.finished = false;

  this.spacebar = game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR);
  this.spacebar.onDown.add(function() {
    this.active = !this.active;
  }, this);

  G.sb("onGoalAchieved").add(function() {
    this.finished = true;
  }, this);
};

G.BOT.prototype = Object.create(Phaser.Group.prototype);

G.BOT.prototype.update = function() {
  if (!this.active || this.finished) {
    G.IMMEDIATE = false;
    return;
  }

  G.IMMEDIATE = true;

  if (this.active
    && this.board.isIdle()
    && this.board.possibleMoves[0]) {
    this.makeMove();

  }
};

G.BOT.prototype.makeMove = function() {
  var move = game.rnd.pick(this.board.possibleMoves);
  var candy1 = this.board.getCandy(move[0], move[1]);
  var candy2 = this.board.getCandy(move[2], move[3]);
  this.board.makeMove(candy1, candy2);
};